/**
 * /pwa – PWA home screen entry point (pure redirector).
 * Uses useNavigate + useEffect with didRedirect guard.
 */
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useFamily } from "@/hooks/useFamily";
import { hasChildSession, isChildDevice } from "@/lib/device";

export default function PwaEntry() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { hasFamily, isLoading } = useFamily();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (didRedirect.current) return;
    if (loading || isLoading) return;
    didRedirect.current = true;

    if (user && hasFamily) { navigate("/dashboard", { replace: true }); return; }
    if (user && !hasFamily) { navigate("/onboarding", { replace: true }); return; }
    if (hasChildSession()) { navigate("/child/access", { replace: true }); return; }
    if (isChildDevice()) { navigate("/start", { replace: true }); return; }

    // Standalone PWA (home screen) → pairing flow; browser → login
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as any).standalone === true;
    navigate(isStandalone ? "/start" : "/login", { replace: true });
  }, [loading, isLoading, user, hasFamily, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <p className="text-muted-foreground">Laster…</p>
    </div>
  );
}
